const config = {

  // 测试服务器前端页面 http://webs.jingjiankj.cn/   后台页面http://back.jingjiankj.cn/Home/Login
  // 接口地址 测试服务器
     //   baseUrl: 'http://api.jingjiankj.cn',
  // 接口地址 正式服务器
    baseUrl: 'https://api.shoujikonghao.com',
  // 图片地址
  imgUrl: 'http://127.0.0.1:5001',
  // 图片上传地址
  imgUploadUrl: 'http://127.0.0.1:5001',
  // 验证码地址
  vCodeUrl: '/verify/generate-image',
  // 默认头像
  defaultAvatar: '/static/img/default_user.png',

  // 版本
  version: {
    no: '1.0.0',
    desc: '--'
  }
}

export default config
